import { Component, Vue } from "vue-property-decorator";
import { ReviewerPeersInterface } from "@/models/reviewer-peers-lists/reviewer-peers-lists.interface";
import moment from "moment";
import {
  dateRange,
  reviewerDataTable,
} from "@/models/common-interface/common.interface";
import DateRangePicker from "@/components/date-range-picker-local/components/DateRangePicker.vue";
import { getApplicationDetails } from "@/providers/apis/getApplictionDetails";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { utils } from "@/utils/utils";
import {
  SortingKeyName,
  SortingOrderKey,
  TableSortEvent,
  FilterStateStorageNames,
} from "@/models/constants/filters.interface";
import { filters } from "@/models/reviewer-peers-lists/reviewer-peers-lists.interface";
import { PEER_FLAG_APPLICANT_QUERY } from "@/graphql/peer-flag-applicant";
import FlagApplicantPopupComponent from "../flag-applicant/flag-applicant.component.vue";
import { gql } from "graphql-tag";
import { DEMOGRAPHIC_QUERY } from "@/graphql/demographic-query";
import { INITIAL_APPLICATION_QUERY } from "@/graphql/training-application-form-query";
@Component({
  name: "reviewer-peers-page",
  components: {
    DateRangePicker,
    AppLoaderComponent,
    FlagApplicantPopupComponent,
  },
})
export default class ReviewerPeersPage extends Vue {
  public peersData: ReviewerPeersInterface[] = [];
  public limit = 10;
  public currentPage = 1;
  public totalItem = 0;
  public page = 1;
  public filterDetails: filters = {} as filters;
  public showFilters = false;
  public dateRange: dateRange = {} as dateRange;
  public certifiedDateRange: dateRange = {} as dateRange;
  public startDate: any;
  public endDate: any;
  public expiryFromDate: any;
  public expiryToDate: any;
  public offset = 0;
  public dateFilter = "";
  public firstName: any;
  public lastName: any;
  public email: any;
  public isLoading = false;
  public errorMessage = "";
  public isDataEmpty = false;
  public sort = "first_name,last_name";
  public sortBy = SortingOrderKey.ASC;
  public certifiedDateFilter = "";
  public tableFields = [
    { key: "firstName", label: "First Name", sortable: true },
    { key: "lastName", label: "Last Name", sortable: true },
    { key: "email", label: "Email Address", sortable: true },
    {
      key: "certificateNumber",
      label: "Certificate Number",
      sortable: true,
      thClass: "certifiactions",
    },
    {
      key: "certificateDate",
      label: "Certified Date",
      sortable: true,
      thClass: "certifiactions",
    },
    {
      key: "expiryDate",
      label: "Expiration Date",
      sortable: true,
      thClass: "renewal_date",
    },
    {
      key: "action",
      label: "Action",
      thClass: "application_action pointer-events",
    },
  ];
  public flagSelected: any = [];
  public flagApplicantNameGet: any = [];
  public flagFiterChip = false;
  public flagPageData: any = {};
  public flagApplicantGrapql: any = {};
  public flagApplicantPopUp = false;
  public certifiedReporDateRange: dateRange = {} as dateRange;
  public certifieDateReportFilter = "";
  public ageRange = [
    {
      lable: "18-30",
      name: "Age 18-30",
      fromAge: "18",
      toAge: "30",
    },
    {
      lable: "31-50",
      name: "Age 31-50",
      fromAge: "31",
      toAge: "50",
    },
    {
      lable: "51+",
      name: "Age 51+",
      fromAge: "51",
      toAge: "100",
    },
  ];
  public isReport: any;
  public count: any;
  public toogleStatus = false;
  public toogleEducation = false;
  public toogleRegion = false;
  public toogleAge = false;
  public fromDate: any;
  public toDate: any;
  public type: any;
  public formData: any;
  public applicationData: any;
  public ethnicDetail: any;
  public genderDetail: any;
  public educationOptions: any;
  public regions: any;
  public filterDate: any;
  public applyEthnicityData: any;
  public applyEducationData: any;
  public applyRegionData: any;
  public applyAgeData: any;
  public filter: any;
  public toAge: any;
  public fromAge: any;
  public created() {
    this.isReport = this.$route.query.isReport;
    if (this.isReport) {
      const peerFilter = localStorage.getItem(FilterStateStorageNames.PEERS)
        ? JSON.parse(localStorage.getItem(FilterStateStorageNames.PEERS) || "")
        : null;
      if (peerFilter) {
        localStorage.removeItem(FilterStateStorageNames.PEERS);
        this.limit = peerFilter.limit || this.limit;
        this.offset = peerFilter.offset || this.offset;
        this.page = (this.offset + this.limit) / 10;
        this.fromDate = peerFilter.fromDate || this.fromDate;
        this.toDate = peerFilter.toDate || this.toDate;
        if (
          this.$route.query.fromDate === this.fromDate &&
          this.$route.query.toDate === this.toDate
        ) {
          this.certifieDateReportFilter = "";
        } else {
          this.certifieDateReportFilter = this.fromDate + " - " + this.toDate;
        }
      } else {
        this.fromDate = this.$route.query.fromDate;
        this.toDate = this.$route.query.toDate;
      }
      this.count = this.$route.query.count;
      this.type = this.$route.query.type;
      this.toAge = this.$route.query.toAge;
      this.fromAge = this.$route.query.fromAge;
      this.filterDate =
        moment(this.fromDate).format("MMM DD") +
        "-" +
        moment(this.toDate).format("MMM DD");
      if (this.$route.query.ethnicity) {
        this.applyEthnicityData = {
          label: this.$route.query.ethnicity,
        };
      }
      if (this.$route.query.region) {
        this.applyRegionData = {
          id: this.$route.query.regionId,
          name: this.$route.query.region,
        };
      }
      if (this.$route.query.age) {
        this.applyAgeData = {
          name: this.$route.query.age,
          fromAge: this.fromAge,
          toAge: this.toAge,
        };
      }
      if (this.$route.query.education) {
        this.applyEducationData = {
          name: this.$route.query.education,
        };
      }
      this.getPeerReports();
      this.getRegionList();
      this.$apollo
        .query({
          query: gql`query ${INITIAL_APPLICATION_QUERY}`,
        })
        .then((result) => {
          this.applicationData = result.data.initialApplications.data;
          this.formData = this.applicationData[0].attributes.form_fields;
          const educationDetail = this.formData.find((data: any) => {
            return data.parent_slug === "certificationPartTwoApplicationForm";
          });
          educationDetail.fields.formInputs.map((formInput: any) => {
            const education = formInput.find((inputData: any) => {
              return inputData.name === "highSchool";
            });
            if (education && education.propBind && education.propBind.options) {
              this.educationOptions = education.propBind.options;
            }
          });
        });
      this.$apollo
        .query({
          query: gql`query ${DEMOGRAPHIC_QUERY}`,
        })
        .then((result) => {
          this.ethnicDetail =
            result.data.demographicDatas.data[0].attributes.fields.formInputs[0][2].propBind.fieldGroups;
        });
    } else {
      const peerFilter = localStorage.getItem(FilterStateStorageNames.PEERS)
        ? JSON.parse(localStorage.getItem(FilterStateStorageNames.PEERS) || "")
        : null;
      if (peerFilter) {
        this.filterDetails = { ...this.filterDetails, ...peerFilter };
        localStorage.removeItem(FilterStateStorageNames.PEERS);
        this.expiryFromDate = peerFilter.expiryFromDate;
        this.expiryToDate = peerFilter.expiryToDate;
        this.startDate = peerFilter.startDate;
        this.endDate = peerFilter.endDate;
        this.limit = peerFilter.limit || this.limit;
        this.offset = peerFilter.offset || this.offset;
        this.page = (this.offset + this.limit) / 10;
        this.dateFilter =
          peerFilter && peerFilter.expiryFromDate && peerFilter.expiryToDate
            ? peerFilter.expiryFromDate + " - " + peerFilter.expiryToDate
            : "";
        this.certifiedDateFilter =
          peerFilter &&
          peerFilter.certificateFromDate &&
          peerFilter.certificateToDate
            ? peerFilter.certificateFromDate +
              " - " +
              peerFilter.certificateToDate
            : "";
      }
      this.getPeerApplicationLists();
    }
    this.flagApplicantGrapqlQuery();
  }

  public loadContent(page: number) {
    this.page = page;
    this.offset = (this.page - 1) * this.limit;
    if (this.isReport) {
      this.getPeerReports();
    } else {
      this.getPeerApplicationLists();
    }
  }

  public navigation(peer: any) {
    localStorage.setItem(
      FilterStateStorageNames.PEERS,
      JSON.stringify(this.filterDetails)
    );
    let query;
    if (this.isReport) {
      query = {
        id: peer.id,
        type: this.$route.query.type,
        isReport: this.$route.query.isReport,
        count: this.$route.query.count,
        fromDate: this.$route.query.fromDate,
        toDate: this.$route.query.toDate,
        ethnicity: this.applyEthnicityData?.label,
        region: this.applyRegionData?.name,
        regionId: this.applyRegionData?.id,
        age: this.applyAgeData?.name,
        education: this.applyEducationData?.name,
        fromAge: this.applyAgeData?.fromAge,
        toAge: this.applyAgeData?.toAge,
        content: this.$route.query.content,
      };
    } else {
      query = {
        id: peer.id,
      };
    }
    this.$router.push({
      path: `peers/${peer.item.id}`,
      query: query,
    });
  }

  public searchOnEnter() {
    this.getPeerApplicationLists();
  }

  public clearSearchText() {
    this.page = 1;
    this.offset = 0;
    this.flagSelected = [];
    this.filterDetails.firstName = "";
    this.filterDetails.lastName = "";
    this.filterDetails.email = "";
    this.startDate = "";
    this.endDate = "";
    this.expiryFromDate = "";
    this.expiryToDate = "";
    this.dateFilter = "";
    this.certifiedDateFilter = "";
    this.filterDetails.certificateNumber = "";
    this.sort = "first_name,last_name";
    this.sortBy = SortingOrderKey.ASC;
    if (this.isReport) {
      this.applyEthnicityData = "";
      this.applyEducationData = "";
      this.applyRegionData = "";
      this.applyAgeData = "";
      this.filterDetails.ethnicity = "";
      this.filterDetails.gender = "";
      this.filterDetails.education = "";
      this.filterDetails.region = "";
      this.filterDetails.fromAge = "";
      this.filterDetails.toAge = "";
      this.certifieDateReportFilter = "";
      this.DateResetDefault();
      this.getPeerReports();
    } else {
      this.getPeerApplicationLists();
    }
  }
  public DateResetDefault() {
    this.certifiedReporDateRange.startDate = this.$route.query.fromDate;
    this.certifiedReporDateRange.endDate = this.$route.query.toDate;
    this.fromDate = moment(
      new Date(this.certifiedReporDateRange.startDate)
    ).format("MM-DD-YYYY");
    this.toDate = moment(new Date(this.certifiedReporDateRange.endDate)).format(
      "MM-DD-YYYY"
    );
    this.certifieDateReportFilter = this.fromDate + " - " + this.toDate;
    this.filterDate =
      moment(this.certifiedReporDateRange.startDate).format("MMM DD") +
      "-" +
      moment(this.certifiedReporDateRange.endDate).format("MMM DD");
    this.certifieDateReportFilter = "";
  }

  public getPeerApplicationLists() {
    this.filterDetails.flags =
      this.flagApplicantNameGet.length == 0
        ? (this.flagSelected = [])
        : this.flagSelected;
    this.filterDetails.limit = this.limit;
    this.filterDetails.offset = this.offset;
    this.filterDetails.expiryFromDate = this.expiryFromDate;
    this.filterDetails.expiryToDate = this.expiryToDate;
    this.filterDetails.certificateFromDate = this.startDate;
    this.filterDetails.certificateToDate = this.endDate;
    this.filterDetails.sortBy = this.sort;
    this.filterDetails.sort = this.sortBy;
    this.isLoading = true;
    const email = this.filterDetails.email
      ? encodeURIComponent(this.filterDetails.email)
      : null;
    this.peersData = [];
    getApplicationDetails
      .getPeersApplicationList({ ...this.filterDetails, email })
      .then((data) => {
        this.peersData = data.peers;
        this.isLoading = false;
        this.totalItem = data.totalCount;
        if (data.peers.length > 0) {
          this.isDataEmpty = false;
        } else {
          this.isDataEmpty = true;
        }
        this.peersData.forEach((element: ReviewerPeersInterface) => {
          element.certificateDate = element.certificateDate
            ? moment(element.certificateDate).format("MM-DD-YYYY")
            : "--";
          element.expiryDate = element.expiryDate
            ? moment(element.expiryDate).format("MM-DD-YYYY")
            : "--";
          element.certificateNumber = element.certificateNumber
            ? element.certificateNumber
            : "--";
        });
      })
      .catch((error: any) => {
        this.isDataEmpty = true;
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }

  public formTypeTableRowClass(item: reviewerDataTable, type: string) {
    return utils.formTypeTableRowClass(item, type);
  }

  public sortChanged(event: TableSortEvent) {
    if (event) {
      this.page = 1;
      this.offset = 0;
      this.currentPage = 1;
    }
    if (
      event.sortBy &&
      SortingKeyName[event.sortBy as keyof typeof SortingKeyName] !== undefined
    ) {
      this.sort = SortingKeyName[event.sortBy as keyof typeof SortingKeyName];
      this.sortBy = event?.sortDesc
        ? SortingOrderKey.DESC
        : SortingOrderKey.ASC;
    }
    this.getPeerReportsAndApplicationList();
  }
  public dateChip(type: any) {
    if (this.dateRange) {
      if (type === "expiry") {
        this.expiryFromDate = moment(new Date(this.dateRange.startDate)).format(
          "MM-DD-YYYY"
        );
        this.expiryToDate = moment(new Date(this.dateRange.endDate)).format(
          "MM-DD-YYYY"
        );
        this.dateFilter = this.expiryFromDate + " - " + this.expiryToDate;
      }
    }
    if (this.certifiedDateRange) {
      if (type === "cerified") {
        this.startDate = moment(
          new Date(this.certifiedDateRange.startDate)
        ).format("MM-DD-YYYY");
        this.endDate = moment(new Date(this.certifiedDateRange.endDate)).format(
          "MM-DD-YYYY"
        );
        this.certifiedDateFilter = this.startDate + " - " + this.endDate;
      }
    }
    if (this.isReport) {
      if (type === "report") {
        this.fromDate = moment(
          new Date(this.certifiedReporDateRange.startDate)
        ).format("MM-DD-YYYY");
        this.toDate = moment(
          new Date(this.certifiedReporDateRange.endDate)
        ).format("MM-DD-YYYY");
        this.certifieDateReportFilter = this.fromDate + " - " + this.toDate;
        this.filterDate =
          moment(this.certifiedReporDateRange.startDate).format("MMM DD") +
          "-" +
          moment(this.certifiedReporDateRange.endDate).format("MMM DD");
      }
    }
    this.offset = 0;
    this.currentPage = 1;
  }
  public onClearStatusFilter(isDateFilter = false, index: any, type = "") {
    if (this.isReport) {
      if (type === "ethnic") {
        this.applyEthnicityData = "";
        this.filterDetails.ethnicity = "";
      }
      if (type === "education") {
        this.applyEducationData = "";
        this.filterDetails.education = "";
      }
      if (type === "region") {
        this.applyRegionData = "";
        this.filterDetails.region = "";
      }
      if (type === "age") {
        this.applyAgeData = "";
        this.filterDetails.fromAge = "";
        this.filterDetails.toAge = "";
      }
      if (type === "date") {
        this.certifieDateReportFilter = "";
        this.DateResetDefault();
      }
      this.offset = 0;
      this.currentPage = 1;
      this.getPeerReports();
    } else {
      if (isDateFilter) {
        this.dateFilter = "";
        this.expiryFromDate = "";
        this.expiryToDate = "";
        this.dateRange.startDate = null;
        this.dateRange.endDate = null;
      } else {
        this.certifiedDateFilter = "";
        this.startDate = "";
        this.endDate = "";
        this.certifiedDateRange.startDate = null;
        this.certifiedDateRange.endDate = null;
      }
      this.offset = 0;
      this.currentPage = 1;
      this.getPeerApplicationLists();
    }
  }
  public flagApplicantGrapqlQuery() {
    this.$apollo
      .query({
        query: gql`query ${PEER_FLAG_APPLICANT_QUERY}`,
      })
      .then((result) => {
        this.flagApplicantGrapql = result;
      });
  }
  public flagOnClearChip(flagIndexGet: any) {
    const chipClearFilter = this.flagSelected.filter(function (value: any) {
      return value !== flagIndexGet.item;
    });
    this.flagSelected = chipClearFilter;
    this.flagDropDownApply();
  }
  public flagDropDownApply() {
    (this.$refs.dropdown as any).hide();
    this.flagApplicantNameGet =
      this.flagApplicantGrapql.data.peerFlagApplicant.data.attributes.form_fields.formInputs[0][0].propBind.options.filter(
        (person: any) => this.flagSelected.includes(person.item)
      );
    this.getPeerApplicationLists();
  }
  public flagDropDownCheckBox() {
    if (this.flagSelected.length >= 1) {
      this.flagFiterChip = true;
    } else {
      this.flagFiterChip = false;
    }
  }
  public onClearFlagFilter() {
    this.flagSelected = [];
  }

  public getPeerReportsAndApplicationList() {
    if (this.isReport) {
      this.getPeerReports();
    } else {
      this.getPeerApplicationLists();
    }
  }

  public flagApplicantPopup() {
    this.getPeerReportsAndApplicationList();
  }
  public flagApplicant(row: any) {
    this.$bvModal.show("flag-applicant-modal");
    this.flagPageData = row.item;
  }
  public getPeerReports() {
    this.filterDetails.limit = this.limit;
    this.filterDetails.offset = this.offset;
    this.filterDetails.fromDate = this.fromDate;
    this.filterDetails.toDate = this.toDate;
    this.filterDetails.sortBy = this.sort;
    this.filterDetails.sort = this.sortBy;
    if (this.applyEthnicityData) {
      this.filterDetails.ethnicity = this.applyEthnicityData.label;
    }
    if (this.applyEducationData) {
      this.filterDetails.education = this.applyEducationData.name;
    }
    if (this.applyRegionData) {
      this.filterDetails.region = this.applyRegionData.id;
    }
    if (this.applyAgeData) {
      this.filterDetails.fromAge = this.applyAgeData.fromAge;
      this.filterDetails.toAge = this.applyAgeData.toAge;
    }
    this.isLoading = true;
    getApplicationDetails
      .getReportPeersApplicationList({ ...this.filterDetails })
      .then((data) => {
        this.peersData = data.peers;
        this.isLoading = false;
        this.totalItem = data.totalCount;
        this.count = data.totalCount;
        if (data.peers.length > 0) {
          this.isDataEmpty = false;
        } else {
          this.isDataEmpty = true;
        }
        this.peersData.forEach((element: ReviewerPeersInterface) => {
          element.certificateDate = element.certificateDate
            ? moment(element.certificateDate).format("MM-DD-YYYY")
            : "--";
          element.expiryDate = element.expiryDate
            ? moment(element.expiryDate).format("MM-DD-YYYY")
            : "--";
          element.certificateNumber = element.certificateNumber
            ? element.certificateNumber
            : "--";
        });
      })
      .catch((error) => {
        this.isDataEmpty = true;
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }
  public getRegionList() {
    getApplicationDetails.getRegionList().then((item) => {
      this.regions = item.data.regions;
    });
  }
  public goBackReport() {
    let query;
    if (this.isReport) {
      query = {
        isReport: this.$route.query.isReport,
        fromDate: this.$route.query.fromDate,
        toDate: this.$route.query.toDate,
      };
    }
    this.$router.push({
      path: `/reviewer-dashboard/reports`,
      query: query,
    });
  }
  public onSelectReportFilter(data: any, isContent: any) {
    this.toogleStatus = false;
    this.toogleRegion = false;
    this.toogleEducation = false;
    this.toogleAge = false;
    if (isContent === "ethnic") {
      this.applyEthnicityData = data;
    }
    if (isContent === "education") {
      this.applyEducationData = data;
    }
    if (isContent === "region") {
      this.applyRegionData = data;
    }
    if (isContent === "age") {
      this.applyAgeData = data;
    }
  }
  public toggleFilter(type = "") {
    if (type === "region") {
      this.toogleStatus = false;
      this.toogleEducation = false;
      this.toogleAge = false;
      this.toogleRegion = !this.toogleRegion;
    }
    if (type === "education") {
      this.toogleStatus = false;
      this.toogleRegion = false;
      this.toogleAge = false;
      this.toogleEducation = !this.toogleEducation;
    }

    if (type === "age") {
      this.toogleStatus = false;
      this.toogleRegion = false;
      this.toogleEducation = false;
      this.toogleAge = !this.toogleAge;
    }
    if (type === "ethnicity") {
      this.toogleRegion = false;
      this.toogleEducation = false;
      this.toogleAge = false;
      this.toogleStatus = !this.toogleStatus;
    }
  }
}
